export default __webpack_public_path__ + "static/media/hero-background.653570ff.png";